import { CloseOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, Space } from 'antd';
import React, { useState } from 'react';

import { NoteItem } from './component/NoteItem';
import { CLOSE_ICON_STYLES, DRAWER_BODY_STYLES, noteList } from './constants';
import styles from './index.module.scss';

type NoteDrawerProps = {
  open: boolean;
  closeDrawer: () => void;
};

export const NoteDrawer = ({ open, closeDrawer }: NoteDrawerProps) => {
  const [noteMessage, setNoteMessage] = useState('');

  const addNote = () => {
    console.log('newNoteMessage', noteMessage);
    // TODO: 邏輯待寫
  };

  return (
    <Drawer
      open={open}
      destroyOnClose
      maskClosable={false}
      closable={false}
      bodyStyle={DRAWER_BODY_STYLES}
    >
      <div className={styles.drawerContent}>
        <div className={styles.closeButtonBox}>
          <button className={styles.closeButton} onClick={closeDrawer}>
            <CloseOutlined rev={undefined} style={CLOSE_ICON_STYLES} />
          </button>
        </div>

        <div className={styles.drawerTitleBox}>
          <p className={styles.title}>備註</p>
        </div>

        <ul className={styles.noteList}>
          {noteList.map((item) => {
            return <NoteItem key={item.id} {...item} />;
          })}
        </ul>

        <div className={styles.noteInput}>
          <Input.TextArea
            placeholder="請輸入內容"
            bordered={false}
            autoSize={{ minRows: 6, maxRows: 6 }}
            value={noteMessage}
            onChange={(event) => setNoteMessage(event.target.value)}
          />

          <Space className={styles.buttons}>
            <Button
              type="link"
              disabled={!noteMessage}
              onClick={() => setNoteMessage('')}
            >
              取消
            </Button>
            <Button type="primary" disabled={!noteMessage} onClick={addNote}>
              送出
            </Button>
          </Space>
        </div>
      </div>
    </Drawer>
  );
};
